import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const routes: RouteRecordRaw = {
  path: '/enquiry-management',
  name: 'EnquiryManagement',
  redirect: '/enquiry-management/quotation-management',
  component: Layout,
  meta: {
    title: '报价管理',
    icon: 'enquiry-management|svg'
  },
  children: [
    {
      path: 'quotation-management',
      name: 'QuotationManagement',
      component: () =>
        import('@/views/EnquiryManagement/quotation-management/quotation-management.vue'),
      meta: {
        title: '我的货源',
        module: 'QUOTATION_MANAGEMENT'
      }
    },
    {
      path: 'demand-sourcing',
      name: 'DemandSourcing',
      component: () => import('@/views/EnquiryManagement/demand-sourcing/demand-sourcing.vue'),
      meta: {
        title: '需求报价',
        module: 'DEMAND_SOURCING'
      }
    },
    {
      path: 'product-matching',
      name: 'ProductMatching',
      component: () => import('@/views/EnquiryManagement/product-matching/product-matching.vue'),
      meta: {
        title: '商品对码',
        module: 'PRODUCT_MATCHING'
      }
    }
  ]
}
export default routes
